const initialState = {
  user: null,
  token: null,
  groupPermission: null
};

export const userProfileReducer = (prevState = initialState, action) => {
  const {type,payload} = action
  let newState = {...prevState}
  switch (type) {
    case 'login':
      newState.user = payload.user
      newState.token = payload.token
      newState.groupPermission = payload.groupPermission
      return newState
    case 'logout':
      return initialState;
    default:
      return prevState;
  }
};

